import SubsectionHeader from '../components/subsection-header/subsection-header';
import SubsectionFooter from '../components/subsection-footer/subsection-footer';
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import RetailKeyMotivator from './retail-key-motivator';
import RetailSummary from './retail-summary';
import './retail.scss';
import { useState, useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

// References for Retail Section
const retailUsageReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."}
];

const retailPlanningReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "Data is based on prior reports of the U.S. Census Bureau."}
];

const retailIntegrationReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."}
];

const retailMetricsReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."}
];

const retailFutureReferences = [
  {reference: "Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "“<a href='https://www.lob.com/blog/4-direct-mail-marketing-myths-debunked' target='_blank'>4 Direct Mail Marketing Myths Debunked</a>,” Lob, Oct. 4, 2022."}
];

export default function Retail() {

  const url = useLocation();
  const path = url.pathname;
  const segment = path.substring(path.lastIndexOf('/') + 1);
  const currentSection = "Retail";
  const keyTakeaways = false;

  // Hero Headings
  const h1 = "Retail";
  const h2 = "Direct Mail in the Retail Industry:";
  const subtext = "Key Stats and Insights";
  const heroAlt = "Monochromatic green shapes arranged across a gridded green background.";

  // Initial References - Retail Usage 
  const [references, setReferences] = useState(retailUsageReferences);
  
  //console.log(retailUsageReferences);

  useEffect(() => {

    switch (segment) {
      case "retail": 
        setReferences(retailUsageReferences);
        break;
      case "planning": 
        setReferences(retailPlanningReferences);
        break;
      case "integration": 
        setReferences(retailIntegrationReferences);
        break;
      case "metrics": 
        setReferences(retailMetricsReferences);
        break;
      case "future": 
        setReferences(retailFutureReferences);
        break;
    }
    
  }, [url]);

  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [url.pathname]);

  return (
    <>
      <div className="retail">
        <div className='container' data-aos="fade-up">
          <SubsectionHeader currentSection={currentSection} heroAlt={heroAlt} h1={h1} h2={h2} subtext={subtext}/>
          <Outlet />
          <SubsectionFooter currentSection={currentSection} KeyMotivator={RetailKeyMotivator} Summary={RetailSummary} references={references} keyTakeaways={keyTakeaways} />
        </div>
      </div>
    </>
  );
}
